import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import { timeEntriesKeys } from './useTimeEntriesQuery';
import { monthlyRatesKeys } from './useMonthlyRatesQuery';
import { taxExpensesKeys } from './useTaxExpensesQuery';

export const useRealtimeSync = (userId: string | null) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!userId) return;

    const userFilter = `user_id=eq.${userId}`;
    const channel = supabase
      .channel(`waer-data-${userId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'time_entries',
          filter: userFilter,
        },
        () => {
          void queryClient.invalidateQueries({ queryKey: timeEntriesKeys.all });
          void queryClient.invalidateQueries({ queryKey: monthlyRatesKeys.all });
        },
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'monthly_rates',
          filter: userFilter,
        },
        () => {
          void queryClient.invalidateQueries({ queryKey: monthlyRatesKeys.all });
        },
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'tax_expenses',
          filter: userFilter,
        },
        () => {
          void queryClient.invalidateQueries({ queryKey: taxExpensesKeys.all });
        },
      )
      .subscribe((status) => {
        if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
          console.error(`Realtime subscription failed: ${status}`);
        }
      });

    return () => {
      void supabase.removeChannel(channel);
    };
  }, [queryClient, userId]);
};
